import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import GradeProgressData from './component'
import { ALL_LESSONS_KEY } from './constants'

const GradeProgressDataContainer = ({ lessonSelectedRow, ...passThrough }) => {
  const selectedTab = lessonSelectedRow?.selectedUnitTab ?? ALL_LESSONS_KEY
  return (
    <GradeProgressData
      {...passThrough}
      key={`grade-${passThrough.grade}-progress`}
      selectedTab={selectedTab}
    />
  )
}

const mapStateToProps = ({
  userSessionManager: {
    adminDashboard: { lessons },
  },
}) => {
  return {
    lessonSelectedRow: lessons.lessonSelectedRow,
  }
}

GradeProgressDataContainer.propTypes = {
  bhuStatus: PropTypes.bool,
  className: PropTypes.string,
  classesNotStarted: PropTypes.number,
  dwbProgressBars: PropTypes.bool,
  grade: PropTypes.string,
  lessonSelectedRow: PropTypes.object,
  lessonsCompleted: PropTypes.number,
  numOfClasses: PropTypes.number,
  siteId: PropTypes.number,
  totalLessons: PropTypes.number,
}

export default connect(mapStateToProps, null)(GradeProgressDataContainer)
